module.exports = __webpack_public_path__ + "static/media/SlideArrowLeft.4fe8d813.svg";